import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { API } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("arth_token", res.data.token);
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-night flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link data-testid="back-to-site-link" to="/" className="text-xs text-muted-foreground hover:text-gold transition-colors flex items-center gap-1 mb-8">
          <ArrowLeft size={14} /> Back to site
        </Link>
        <div className="bg-slate2 border border-white/10 p-10">
          <div className="mb-2">
            <span className="inline-flex bg-white rounded-md px-4 py-2.5 items-center shadow-md shadow-black/30">
              <img src="/globus-lockup.png" alt="Globus Financial Services" className="h-10 w-auto object-contain" />
            </span>
          </div>
          <p className="text-sm text-muted-foreground mb-10">Advisor dashboard — sign in to manage enquiries.</p>
          <form onSubmit={submit} data-testid="admin-login-form" className="space-y-6">
            <div>
              <Label htmlFor="admin-email" className="text-sm text-[#A0AAB2] mb-2 block">Email</Label>
              <Input
                data-testid="admin-email-input"
                id="admin-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-slate3 border-white/10 rounded-sm"
              />
            </div>
            <div>
              <Label htmlFor="admin-password" className="text-sm text-[#A0AAB2] mb-2 block">Password</Label>
              <Input
                data-testid="admin-password-input"
                id="admin-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-slate3 border-white/10 rounded-sm"
              />
            </div>
            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-gold text-night hover:bg-goldhover transition-colors rounded-sm px-6 py-3 font-semibold flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading && <Loader2 size={16} className="animate-spin" />}
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
